import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Retorno } from '@app/models/retorno';


@Injectable({
  providedIn: 'root'
})
export class PesquisaSatisfacaoService {

  readonly APIUrl = `${environment.urlApiPesquisaSatisfacao}`

  usuario: any;

  idSolicitacao: number;
  nomeUsuario: string;
  loginUsuario: string;
  matriculaUsuario: string;
  idUsuario: number;

  existeSolicitacao: boolean;

  constructor(private http: HttpClient) { }

  //Usuário
  getUsuario(usuario: String) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.urlApiPesquisaSatisfacao}/api/usuario/getUsuario/${usuario}`
        )
        .subscribe(
          (result) => {
            //this.serviceGlobal.exibirMensagem(result);
            this.usuario = result;
            resolve(this.usuario);
          },
          (error) => {
            //this.serviceGlobal.exibirMensagem(error);
            let retorno:Retorno;
            retorno.sucesso = false;
            retorno.mensagem = error;
            resolve(retorno);
          }
        );
    });
  }


  getSolicitacaoPorId(id: number) {
    //return this.http.get<any[]>(this.APIUrl + '/api/solicitacao/buscarPorId/'+id);
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.APIUrl}/api/solicitacao/buscarPorId/${id}`
        )
        .subscribe(
          (result: any) => {
            //this.serviceGlobal.exibirMensagem(result);
            resolve(result);
          },
          (error) => {
            //this.serviceGlobal.exibirMensagem(error);
            let retorno:Retorno;
            retorno.sucesso = false;
            retorno.mensagem = error;
            resolve(retorno);
          }
        );
    });
  }

  getSolicitacaoPorFiltro(status: number, matricula: String) {
 //   return this.http.get<any[]>(this.APIUrl + '/api/solicitacao/listarSolicitacaoPorFiltro/' + status + '/' + matricula);
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.APIUrl + '/api/solicitacao/listarSolicitacaoPorFiltro/' + status + '/' + matricula
        )
        .subscribe(
          (result: any[]) => {
            //this.serviceGlobal.exibirMensagem(result);
            resolve(result);
          },
          (error) => {
            //this.serviceGlobal.exibirMensagem(error);
            let retorno:Retorno;
            retorno.sucesso = false;
            retorno.mensagem = error;
            resolve(retorno);
          }
        );
    });
  }

  naoResponder(body) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.APIUrl}/api/solicitacao/naoResponder`,
          body
        )
        .subscribe(
          (result: any) => {
            //this.serviceGlobal.exibirMensagem(result);
            resolve(result);
          },
          (error) => {
            //this.serviceGlobal.exibirMensagem(error);
            let retorno:Retorno;
            retorno.sucesso = false;
            retorno.mensagem = error;
            resolve(retorno);
          }
        );
    });
  }

  salvarRespostas(body) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.APIUrl}/api/resposta/salvar/`,
          body
        )
        .subscribe(
          (result: any) => {
            //this.serviceGlobal.exibirMensagem(result);
            resolve(result);
          },
          (error) => {
            //this.serviceGlobal.exibirMensagem(error);
            let retorno:Retorno;
            retorno.sucesso = false;
            retorno.mensagem = error;
            resolve(retorno);
          }
        );
    });
  }
}
